import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './messages'

Vue.use(VueI18n)

export const supportedLocales = [
  { code: 'zh-CN', native: '简体中文', english: 'Chinese (Simplified)' },
  { code: 'zh-TW', native: '繁體中文', english: 'Chinese (Traditional)' },
  { code: 'en', native: 'English', english: 'English' },
  { code: 'es', native: 'Español', english: 'Spanish' }
]

function normalizeLocale(value) {
  const locale = String(value || '').replace('_', '-').toLowerCase()
  if (locale === 'zh-tw' || locale === 'zh-hk' || locale === 'zh-hant') return 'zh-TW'
  if (locale.startsWith('en')) return 'en'
  if (locale.startsWith('es')) return 'es'
  return 'zh-CN'
}

function initialLocale() {
  if (typeof window === 'undefined') return 'zh-CN'
  return normalizeLocale(window.localStorage.getItem('vervesteel-locale') || window.navigator.language)
}

const i18n = new VueI18n({
  locale: initialLocale(),
  fallbackLocale: 'zh-CN',
  messages,
  silentFallbackWarn: true
})

export function setLocale(locale) {
  const normalized = normalizeLocale(locale)
  i18n.locale = normalized
  if (typeof document !== 'undefined') {
    document.documentElement.lang = normalized
    document.documentElement.dataset.language = normalized === 'zh-TW' ? 'zh-TW' : normalized
  }
  if (typeof window !== 'undefined') window.localStorage.setItem('vervesteel-locale', normalized)
}

setLocale(i18n.locale)

export default i18n
